'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _PurchaseMessageComponent = require('../common/PurchaseMessageComponent');

var _PurchaseMessageComponent2 = _interopRequireDefault(_PurchaseMessageComponent);

var _QuoteComponent = require('../common/QuoteComponent');

var _QuoteComponent2 = _interopRequireDefault(_QuoteComponent);

var _CompleteApplicationButtons = require('../common/CompleteApplicationButtons');

var _CompleteApplicationButtons2 = _interopRequireDefault(_CompleteApplicationButtons);

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prefer-stateless-function */

/**
 * Renders the purchase confirmation message.
 * @extends {Component}
 */
var CompletePurchase = function (_React$Component) {
  _inherits(CompletePurchase, _React$Component);

  function CompletePurchase() {
    _classCallCheck(this, CompletePurchase);

    return _possibleConstructorReturn(this, (CompletePurchase.__proto__ || Object.getPrototypeOf(CompletePurchase)).apply(this, arguments));
  }

  _createClass(CompletePurchase, [{
    key: 'render',
    value: function render() {
      var price = (0, _commonFunctions.rimiVTCProducts)(this.props.formName) ? '$' + (isNaN(parseFloat(this.props.fields.payment.amount.value)) ? 0 : this.props.fields.payment.amount.value) + ' ' + this.props.application.quote.price.split(' ')[1] : this.props.application.quote.price;
      return _react2.default.createElement(
        'div',
        null,
        (0, _url2.default)('user_code', null) ? null : _react2.default.createElement(_PurchaseMessageComponent2.default, _extends({}, this.props, { price: price })),
        _react2.default.createElement(_QuoteComponent2.default, _extends({}, this.props, {
          quoteAmount: this.props.application.quote.price,
          quoteDetails: this.props.application.quote.information
        })),
        _react2.default.createElement(_CompleteApplicationButtons2.default, _extends({}, this.props, {
          pendingPayment: this.props.fields.payment.pending ? parseFloat(this.props.fields.payment.pending.value) > 0 : false
        }))
      );
    }
  }]);

  return CompletePurchase;
}(_react2.default.Component);

CompletePurchase.propTypes = {
  application: _react2.default.PropTypes.object,
  fields: _react2.default.PropTypes.object,
  formName: _react2.default.PropTypes.object
};
exports.default = CompletePurchase;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/CompletePayment.jsx
// module id = 1653
// module chunks = 0